import { useThemesStore } from '../../store';
import { IconConfig } from '../../store/types';

const useGetThemeIcons = (): IconConfig => {
  const { iconsSet = {} } = useThemesStore();
  return iconsSet;
};

export default useGetThemeIcons;
